module.exports = ()->
  return {
    restrict: 'A'
    template: require('./auto-disposition.html')
    scope:
      isAdverse: "=autoDispositionIsAdverse"
      riskTags: "=autoDispositionRiskTags"
      justification: "=autoDispositionJustification"

    controller: ($scope) ->
      $scope.getIsAdverse = () ->
        if $scope.isAdverse?
          if $scope.isAdverse
            return "Relevant"
          return "Irrelevant"

        return null

      $scope.getJustification = () ->
        if $scope.justification?
          return $scope.justification

        return null

      $scope.getRiskTags = () ->
        if $scope.riskTags?
          return $scope.riskTags.join(", ")

        return null
  }
